import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VistaUsuarioContainerComponent } from './components/vista-usuario-container/vista-usuario-container.component';

const routes: Routes = [
  {
    path: '',
    component: VistaUsuarioContainerComponent,
    data: { title: 'rpe.route.vista-usuario' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VistaUsuarioRoutingModule {}
